<template>
  <div class="cores">
    <template>
      <v-card>
        <v-card-title>
          Nxtsof Config
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card>
          <v-container fluid>
            <v-row align="center">
            </v-row>
            <v-row>
              <v-data-table
                :headers="headers"
                :items="nxtsofFiids"
                :items-per-page="10">
                <template slot="items" slot-scope="props">
                  <td>{{ props.item }}</td>
                  <td>
                    <v-btn v-if="userWritePrivileges"
                    color="red"
                    dark
                    @click="deleteFiid(props.item)">
                      <font-awesome-icon icon="trash-alt"  class="pr-1"/>Delete
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <v-dialog
              v-model="dialog"
              persistent
              max-width="500px"
              v-if="userWritePrivileges">
                    <template v-slot:activator="{ on }">
                      <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-on="on">Add FI ID
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Add FI ID</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                              v-model="newFiid"
                              type="number"
                              label="FI ID"
                              :rules="['Required']">
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                        <v-btn v-if="userWritePrivileges" color="blue darken-1" text @click="addFiid()">Add</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
            </v-row>
          </v-container>
        </v-card>
      </v-card>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import RequestService from '@/RequestService';
import NxtsofService from '@/NxtsofService';

@Component
export default class NxtSofConfig extends Vue {
  /*eslint-disable */
  data() {
    return {
      dialog: false,
      newFiid: "",
      standardNxtsofVersion: "v1",
      userWritePrivileges: false,
    };
  }

  /* eslint-enable */
  nxtSofVersions=[];

  nxtsofFiids=[];

  headers = [
    {
      text: 'FI ID',
      value: 'item',
      sortable: true,
      align: 'left',
    },
    { text: 'Actions', value: 'action', sortable: false },
  ];

  emptyPayload = {
    core: 'core',
    version: '',
    fiIds: [],
  };

  editedPayload = this.emptyPayload;

  async addFiid() {
    if (this.nxtsofFiids.includes(this.newFiid)) {
      window.alert(`FI ID ${this.newFiid} already exists.`);
    } else if (this.newFiid === '') {
      window.alert('FI ID cannot be blank.');
    } else {
      if (window.confirm(`Are you sure you want to add FI ID: ${this.newFiid}?`)) {
        this.dialog = true;
        this.nxtsofFiids.push(this.newFiid);
        this.editedPayload.version = this.standardNxtsofVersion;
        this.editedPayload.fiIds = this.nxtsofFiids;
        await NxtsofService.updateNxtsofFiid(this.editedPayload);
        this.newFiid = Object.assign('', this.newFiid);
        this.editedPayload = this.emptyPayload;
      }
      this.close();
    }
  }

  async deleteFiid(item) {
    if (window.confirm(`Are you sure you want to delete FI ID: ${item}?`)) {
      const fiidIdxToDelete = this.nxtsofFiids.indexOf(item);
      this.nxtsofFiids.splice(fiidIdxToDelete, 1);
      this.editedPayload.version = this.standardNxtsofVersion;
      this.editedPayload.fiIds = this.nxtsofFiids;
      await NxtsofService.updateNxtsofFiid(this.editedPayload);
      this.editedPayload = this.emptyPayload;
    }
  }


  close() {
    this.dialog = false;
    setTimeout(() => {
      this.newFiid = '';
    }, 300);
  }

  async mounted() {
    this.nxtsofFiids = await NxtsofService.getAllNxtsofFis();
    this.userWritePrivileges = await RequestService.checkCredentials();
  }
}
</script>
